export default __webpack_public_path__ + "static/media/women.89e857f9.svg";